import { ErrorBaseData } from '.'

export const posologyErrors: Record<string, ErrorBaseData> = {
  PosologyNotFoundException: {
    message: 'Posologia não encontrada',
    description: 'Não foi possível encontrar a posologia. Verifique as informações e tente novamente',
  },
}
